import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TriangleIcon } from '../../../assets/icons';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '8px'
  },
  circle: {
    width: '8px',
    height: '8px',
    borderRadius: 100,
    marginRight: '1px',
    marginLeft: '1px'
  },
  box: {
    width: '8px',
    height: '8px',
    borderRadius: '2px',
    marginRight: '1px',
    marginLeft: '1px'
  },
  triangle: {
    marginRight: '1px',
    marginLeft: '1px',
    transform: 'rotateX(180deg)',
  }
}));

const CollectionsItem = ({
  data = [],
  day
}) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {
        data
        && data.map((item) => {
          if (item.status !== 'is_none') {
            if (item.shape === 'circle') {
              return (
                <div
                  key={`${day} - dayButton - ${item.id}`}
                  className={classes.circle}
                  style={{ backgroundColor: `#${item.color}` }}
                />
              );
            } if (item.shape === 'box') {
              return (
                <div
                  key={`${day} - dayButton - ${item.id}`}
                  className={classes.box}
                  style={{ backgroundColor: `#${item.color}` }}
                />
              );
            }
            return (
              <TriangleIcon
                key={`${day} - dayButton - ${item.id}`}
                color={`#${item.color}`}
                className={classes.triangle}
              />
            );
          }

          return null;
        })
      }

    </div>
  );
};
export default CollectionsItem;
